import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ActionCardTitleProps {
  children: React.ReactNode;
}

const TitleComponent: React.FC<ActionCardTitleProps> = ({ children }) => {
  return <span className="peptalk-action-card-title">{children}</span>;
};

export const Title: React.FC<ActionCardTitleProps> = (
  props: ActionCardTitleProps
) => {
  const Component = useCustomComponent({
    componentName: 'ActionCardTitle',
    Component: TitleComponent,
  });

  return <Component {...props} />;
};
